
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exercise",
      function () {
        return require("private-next-pages/exercise/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exercise"])
      });
    }
  